export default {
	'expected-quantity': 'Expected qty',
	'inventory-qty': 'Inventory qty',
	'reserved-quantity': 'Reserved qty',
	'available-to-sell': 'Able to sell',
	'sales-availability': 'Sales availability',
	'weighted-average-percentage': 'Weighted Average',
	display: 'Display'
}